import { Link } from "react-router-dom";
import { C, font, SHOW_FEATURES_MENU } from "../tokens";
import logoImg from "../assets/site/logo.png";
import appStoreSvg from "../assets/site/app-store.svg";
import googlePlaySvg from "../assets/site/google-play.svg";

// ─── Logo (hp) — variante clara para o footer escuro ───────
function Logo({ size = 36, light = false, to = "/" }) {
  return (
    <Link
      to={to}
      aria-label="IMOBMEET — página inicial"
      onClick={() => {
        try {
          window.scrollTo({ top: 0, behavior: "auto" });
        } catch {}
      }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        textDecoration: "none",
        height: size,
        filter: light ? "brightness(0) invert(1)" : "none",
        transition: "opacity 0.2s",
      }}
      onMouseEnter={(o) => (o.currentTarget.style.opacity = "0.85")}
      onMouseLeave={(o) => (o.currentTarget.style.opacity = "1")}
    >
      <img
        src={logoImg}
        alt="imobmeet"
        style={{ height: size, width: "auto", display: "block" }}
      />
    </Link>
  );
}

// ─── Links de redes sociais (l0) ───────────────────────────
const l0 = [
  {
    label: "Instagram",
    url: "https://www.instagram.com/imobmeet/",
    icon: (
      <>
        <rect x="2" y="2" width="20" height="20" rx="5.5" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="2" />
        <circle cx="17.6" cy="6.4" r="1.3" fill="currentColor" />
      </>
    ),
  },
  {
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/imobmeetcrm",
    icon: (
      <path
        fill="currentColor"
        d="M4.98 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM3 9h4v12H3V9zm6 0h3.8v1.7h.1c.5-.95 1.8-1.95 3.6-1.95 3.9 0 4.6 2.55 4.6 5.85V21h-4v-5.3c0-1.27-.02-2.9-1.77-2.9-1.77 0-2.04 1.38-2.04 2.8V21H9V9z"
      />
    ),
  },
  {
    label: "YouTube",
    url: "https://www.youtube.com/@imobmeetcrm",
    icon: (
      <path
        fill="currentColor"
        d="M23 12s0-3.2-.41-4.74a2.5 2.5 0 0 0-1.76-1.76C19.3 5.1 12 5.1 12 5.1s-7.3 0-8.83.4A2.5 2.5 0 0 0 1.41 7.26C1 8.8 1 12 1 12s0 3.2.41 4.74a2.5 2.5 0 0 0 1.76 1.76c1.53.4 8.83.4 8.83.4s7.3 0 8.83-.4a2.5 2.5 0 0 0 1.76-1.76C23 15.2 23 12 23 12zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"
      />
    ),
  },
];

const a0 = "https://play.google.com/store/apps/details?id=com.imobmeet.imobmeetapp&hl=pt_BR";
const s0 = "https://apps.apple.com/us/app/imobmeet/id6759934477";

// Espelha o array `il` do build para a coluna SOLUÇÕES.
const il = [
  { label: "CRM para Incorporadoras", to: "/crm-incorporadoras", color: "#0560FF" },
  { label: "CRM para Loteadoras", to: "/crm-loteadoras", color: "#10B981" },
  { label: "Sistema para Loteamento", to: "/sistema-para-loteamento", color: "#059669" },
  { label: "CRM para Construtoras", to: "/crm-construtoras", color: "#F59E0B" },
  { label: "Pagadoria inteligente", to: "/split-comissoes", color: "#8B5CF6" },
  { label: "Gestão de Recebíveis", to: "/gestao-de-recebiveis", color: "#F59E0B" },
  { label: "Imobmeet Autovendas", to: "/autovendas", color: "#EC4899" },
  { label: "HUB Whatsapp", to: "/funcionalidades/hub-whatsapp", color: "#25D366" },
];

// ─── Footer (Hn) ───────────────────────────────────────────
export default function Footer() {
  const e = [
    {
      title: "SOLUÇÕES",
      links: il.map((t) => ({
        label: t.label.replace("CRM para ", ""),
        to: t.to,
        color: t.color,
      })),
    },
    {
      title: "INTEGRAÇÕES",
      links: [
        { label: "Sienge ERP", to: "/integracoes" },
        { label: "UAU ERP", to: "/integracoes" },
        { label: "Informakon", to: "/integracoes" },
        { label: "ClickSign", to: "/integracoes" },
        { label: "DocuSign", to: "/integracoes" },
        { label: "Ver todas", to: "/integracoes" },
      ],
    },
    {
      title: "EMPRESA",
      links: [
        ...(SHOW_FEATURES_MENU ? [{ label: "Funcionalidades", to: "/funcionalidades" }] : []),
        { label: "Conteúdo", to: "/conteudo" },
        { label: "Sobre nós", to: "/agendar-demo" },
        { label: "Parceiros", to: "/agendar-demo" },
        { label: "Agendar demo", to: "/agendar-demo" },
        { label: "Contato", to: "/agendar-demo" },
      ],
    },
    {
      title: "AJUDA",
      links: [{ label: "Central de Ajuda", to: "/agendar-demo" }],
    },
  ];

  return (
    <footer
      style={{
        background: "#08102A",
        padding: "72px 28px 32px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="grid-bg-dark" style={{ position: "absolute", inset: 0, opacity: 0.5 }} />
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: -200,
          transform: "translateX(-50%)",
          width: 600,
          height: 600,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(5,96,255,0.18) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />
      <div style={{ maxWidth: 1180, margin: "0 auto", position: "relative" }}>
        <div
          className="footer-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1.7fr 1fr 1fr 1fr 1fr",
            gap: 40,
            marginBottom: 56,
          }}
        >
          <div>
            <Logo light />
            <p
              style={{
                fontFamily: font,
                fontSize: 14,
                color: "#6E7FA0",
                lineHeight: 1.7,
                maxWidth: 290,
                marginTop: 18,
              }}
            >
              CRM all in one para incorporadoras e loteadoras que querem vender mais e gerenciar melhor.
            </p>
            <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
              {l0.map((t) => (
                <a
                  key={t.label}
                  href={t.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t.label}
                  title={t.label}
                  style={{
                    width: 38,
                    height: 38,
                    borderRadius: 10,
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#9FB0D0",
                    textDecoration: "none",
                    transition: "color 0.15s, background 0.15s",
                  }}
                  onMouseEnter={(r) => {
                    r.currentTarget.style.color = "#fff";
                    r.currentTarget.style.background = "rgba(255,255,255,0.12)";
                  }}
                  onMouseLeave={(r) => {
                    r.currentTarget.style.color = "#9FB0D0";
                    r.currentTarget.style.background = "rgba(255,255,255,0.05)";
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24">
                    {t.icon}
                  </svg>
                </a>
              ))}
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 22, flexWrap: "wrap" }}>
              <a href={s0} target="_blank" rel="noopener noreferrer" aria-label="Baixar na App Store">
                <img
                  src={appStoreSvg}
                  alt="Disponível na App Store"
                  style={{ height: 38, display: "block" }}
                />
              </a>
              <a href={a0} target="_blank" rel="noopener noreferrer" aria-label="Baixar no Google Play">
                <img
                  src={googlePlaySvg}
                  alt="Disponível no Google Play"
                  style={{ height: 38, display: "block" }}
                />
              </a>
            </div>
          </div>
          {e.map(({ title, links }) => (
            <div key={title}>
              <div
                style={{
                  fontFamily: font,
                  fontSize: 10,
                  fontWeight: 800,
                  color: C.accent,
                  letterSpacing: 1.6,
                  marginBottom: 18,
                }}
              >
                {title}
              </div>
              {links.map((o) => (
                <Link
                  key={o.label}
                  to={o.to}
                  style={{
                    display: "block",
                    fontFamily: font,
                    fontSize: 13,
                    color: "#6E7FA0",
                    textDecoration: "none",
                    marginBottom: 10,
                    transition: "color 0.15s",
                  }}
                  onMouseEnter={(i) => (i.currentTarget.style.color = "white")}
                  onMouseLeave={(i) => (i.currentTarget.style.color = "#6E7FA0")}
                >
                  {o.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.06)",
            paddingTop: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <span style={{ fontFamily: font, fontSize: 12, color: "#3A4A6A" }}>
            © 2026 IMOBMEET · Todos os direitos reservados
          </span>
          <div style={{ display: "flex", gap: 24 }}>
            {[
              { l: "Termos de Uso", to: "/termos-de-uso" },
              { l: "Política de Privacidade", to: "/politica-de-privacidade" },
              { l: "LGPD", to: "/lgpd" },
            ].map(({ l, to }) => (
              <Link
                key={l}
                to={to}
                style={{
                  fontFamily: font,
                  fontSize: 12,
                  color: "#3A4A6A",
                  textDecoration: "none",
                  transition: "color 0.15s",
                }}
                onMouseEnter={(o) => (o.currentTarget.style.color = "#6E7FA0")}
                onMouseLeave={(o) => (o.currentTarget.style.color = "#3A4A6A")}
              >
                {l}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
